import { brandsLogos } from './brandsLogos';

/* Brands Salfa asked to hide from the brand selector. */
const EXCLUDED_BRANDS = ['jeep', 'ram', 'fiat', 'byd'];

/** Whether the brand is offered as a card in the desktop brand selector. */
const isBrandSelectable = (brand) =>
  !EXCLUDED_BRANDS.some((excludedBrand) => brand.name.toLowerCase().includes(excludedBrand)) &&
  !!brandsLogos[brand.name];

export default isBrandSelectable;
